<template>
  <v-col :cols="cols" align="center">
    <v-sheet
      v-if="!title"
      class="text-center mb-1 "
      color="primary"
      elevation="5"
      dark
    >{{ assembly ? $t('general.assemblyStock') : $t('stats.stock')}} : {{localStock}}</v-sheet>
    <v-sheet
      v-else
      class="text-center mb-1 "
      color="primary"
      elevation="5"
      dark
    >{{$t('general.stockFrom')}} {{title}} : {{localStock}}</v-sheet>
    <v-card elevation="5">
      <v-card-text class>
        <v-scale-transition group v-if="localStock > 0">
          <v-icon v-for="n in localStock" :key="n" class="stock-point">mdi-circle-slice-8</v-icon>
        </v-scale-transition>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
export default {
  name: "Stock",
  props: {
    stock: Number,
    initStock: Number,
    title: {
      type: String,
      default: ""
    },
    cols: {
      type: Number,
      default: 12
    },
    assembly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    localStock: 0
  }),
  mounted () {
    this.localStock = this.initStock
  },
  methods: {
    changeStock (val) {
      if (val > this.localStock) {
        for (let index = 0; index < (val - this.localStock); index++) {
          setTimeout(() => this.$nextTick(() => { this.localStock = this.localStock + 1}), index * 100)
        }
      } else if (val < this.localStock){
        for (let index = 0; index < ( this.localStock - val); index++) {
          setTimeout(() => this.$nextTick(() => { this.localStock = this.localStock - 1}), index * 100)
        }
      }
    }
  },
  watch: {
    stock (val) {
      this.changeStock(val)
    },
    initStock (val) {
      this.localStock = val
    }
  }
};
</script>
<style>
.stock-point {
  font-size: 40px !important;
}
</style>